import { Box, Button, CircularProgress, FormControl, Grid, IconButton, Paper, TextField, Tooltip, Typography } from "@mui/material";
import { format } from 'date-fns';
import { useSnackbar } from "notistack";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { RootState } from "../../../app/store";

import configUrls from "../../../config/configUrls";
import { ProcessoAnotacaoList } from "../../../types/processo/ProcessoAnotacaoList";
import { useDeleteAnotacaoMutation, useDeleteProcessoMutation, useGetProcessoAnotacoesQuery } from "../processoApiSlice";
import { ISprocessoAnotacao, ProcessoAnotacao } from "../../../types/processo/ProcessoAnotacao";
import { GridDeleteIcon } from "@mui/x-data-grid";
import ConfirmDialogList from "../../../components/ConfirmDialogList";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";





export const ProcessoAnotacaoListForm
    = () => {

        const { enqueueSnackbar, closeSnackbar } = useSnackbar()
        const [loading, setLoading] = useState(false);
        const navigate = useNavigate(); // Hook para navegação



        const [anotacoes, setAnotacoes] = useState<ProcessoAnotacaoList[]>([]);

        const [anotacaoToDelete, setAnotacaoToDelete] = useState<ProcessoAnotacao>(ISprocessoAnotacao);
        const [openConfirmExcluir, setOpenConfirmExcluir] = useState(false);
        const [deleteAnotacao, { error: errorAnotacao, isLoading, isSuccess }] = useDeleteAnotacaoMutation();

        const [search, setSearch] = useState<string>("");
        const [debouncedSearch, setDebouncedSearch] = useState<string>("");
        const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
        const inputRef = useRef<HTMLInputElement | null>(null);
        const cursorPosition = useRef<number>(0);

        const handleChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
            cursorPosition.current = inputRef.current?.selectionStart || 0;
            setSearch(e.target.value);
        };

        useEffect(() => {
            // Limpar o timeout anterior
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }

            // Configurar o timeout para o debounce
            debounceTimeout.current = setTimeout(() => {
              
                setDebouncedSearch(search);
            }, 700); // Tempo de debounce (700ms)

            // Limpar o timeout quando o componente for desmontado ou o efeito for reiniciado
            return () => {
                if (debounceTimeout.current) {
                    clearTimeout(debounceTimeout.current);
                }
            };
        }, [search]); // Dependência do useEffect: quando o 'search' mudar



        const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);

        useEffect(() => {
            if (!processoSelecionado) {
                alert("Nenhum processo selecionado");
                window.location.href = configUrls.PROCESSO_LIST_RT
            }
        }, [processoSelecionado]);


        const { data, isFetching, error } = useGetProcessoAnotacoesQuery({ id: processoSelecionado?.id ?? "", search: debouncedSearch, });

        useEffect(() => {
            if (data) {
                setAnotacoes(data);
            }
            if (error) {
                enqueueSnackbar("Anotações não encontradas!", { variant: "error" });
            } else if (isFetching) {
                enqueueSnackbar("Buscando registros...", { variant: "info" });
            }
            if (inputRef.current) {
                inputRef.current.focus(); // Manter o foco no campo de input
            }

            if (inputRef.current) {
                inputRef.current.focus();
                inputRef.current?.setSelectionRange(cursorPosition.current, cursorPosition.current);
            }
        }, [data, error, isFetching, enqueueSnackbar]);



        const headerGerados = (
            <Typography variant="body2" color="textSecondary">
                Anotação(ões) encontrada(s): {anotacoes.length}
            </Typography>
        );

        const renderData = (rowData: ProcessoAnotacaoList) => {
            const dataCriacao = rowData.dataHoraCriacao ? format(rowData.dataHoraCriacao, 'dd/MM/yyyy HH:mm:ss') : "Data não disponível";
            return <Typography color="secondary" variant="body2">{dataCriacao}</Typography>;
        };

        const renderUsuario = (rowData: ProcessoAnotacaoList) => (
            <Typography color="secondary" variant="body2">{rowData.usuario?.nome || "Usuário não disponível"}</Typography>
        );
        const renderDescricao = (rowData: ProcessoAnotacaoList) => (
            <Typography color="secondary" variant="body2">{rowData.descricao || ""}</Typography>
        );

        const renderAction = (rowData: any) => {
            return (
                <Box>
                    <Tooltip title="Editar">
                        <Link to={`${configUrls.PROCESSO_ANOTACAO_EDIT_LK}${rowData.id}`}>
                            <IconButton
                                color="secondary"
                                aria-label="edit"
                            >
                                <EditIcon />
                            </IconButton>
                        </Link>
                    </Tooltip>

                    <Tooltip title="Excluir">
                        <IconButton
                            color="secondary"
                            aria-label="delete"
                            onClick={() => handleExcluirtClick(rowData)}
                        >
                            <GridDeleteIcon />
                        </IconButton>
                    </Tooltip>

                </Box>

            );
        };

        const handleExcluirtClick = (rowData: any) => {
            setAnotacaoToDelete(rowData);
            setOpenConfirmExcluir(true);
        };
        const handleCloseDialog = () => {
            setOpenConfirmExcluir(false);
        };
        const handleConfirm = async () => {
            setOpenConfirmExcluir(false);
            await deleteAnotacao({ id: anotacaoToDelete.id ? anotacaoToDelete.id : "" });
        }

        useEffect(() => {
            if (isSuccess) {
                enqueueSnackbar("Registro deletado com sucesso!", { variant: "success" });
                // fetchDados();
            }
            if (errorAnotacao) {
                enqueueSnackbar("Registro não deletado!", { variant: "error" });
            }


        }, [isSuccess, errorAnotacao]);


        if (isFetching || loading) {
            return (
                <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                    <CircularProgress />
                </Box>
            );
        }





        return (
            <>
                <ConfirmDialogList
                    open={openConfirmExcluir}
                    handleClose={handleCloseDialog}
                    title="Confirmar Ação"
                    text={["Você tem certeza de que deseja excluir essa Anotação?", anotacaoToDelete.descricao ? anotacaoToDelete.descricao : ""]}
                    handleDelete={() => {
                        handleConfirm();  // Chama a função handleConfirm
                        setOpenConfirmExcluir(false);  // Fecha o diálogo
                    }}
                />


                <Paper sx={{ width: "100%", height: "100vh", padding: "12px" }}>
                    <Grid container padding={2}>
                        <Grid item xs={12}>
                            <FormControl fullWidth>

                                <Box display="flex" justifyContent="space-between" mb={2}>

                                    <Box display="flex">
                                        <Typography color="secondary" variant="h6" gutterBottom>
                                            Anotações para o processo: {processoSelecionado?.numeroProcesso}
                                        </Typography>
                                    </Box>


                                    <Box display="flex" justifyContent="flex-end" gap={2}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => { navigate(configUrls.PROCESSO_ANOTACAO_CREATE_RT) }}
                                        >
                                            Novo
                                        </Button>

                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => navigate(-1)}
                                        >
                                            Voltar
                                        </Button>


                                    </Box>
                                </Box>




                            </FormControl>
                        </Grid>

                        <Grid item xs={12} mt={5} >
                            <FormControl fullWidth>
                                <TextField
                                    label="Digite para pesquisar"
                                    name="nome"
                                    onChange={handleChangeSearch}
                                    size="small"
                                    inputProps={{ maxLength: 100 }}
                                    value={search}
                                    inputRef={inputRef}
                                />
                            </FormControl>
                        </Grid>


                    </Grid>

                    <DataTable
                        value={anotacoes}
                        paginator
                        rows={25}
                        showGridlines={true}
                        size="small"
                        columnResizeMode="expand"
                        resizableColumns
                        dataKey="id"
                        header={headerGerados}
                        className="custom-datatable"
                    >

                        <Column header="Data" body={renderData} sortable style={{ width: '20%' }} />
                        <Column header="Descrição" body={renderDescricao} sortable style={{ width: '70%' }} />
                        <Column header="Usuário" body={renderUsuario} sortable style={{ width: '20%' }} />
                        <Column field="acoes" header="Ações" body={renderAction} style={{ width: 'auto' }}></Column>

                    </DataTable>


                </Paper>

            </>







        );










    };
